import DefaultContainer from "../../../components/general/dashboards/default";

const Default = () => {
  return <DefaultContainer />;
};

export default Default;
